module.exports = __webpack_public_path__ + "static/media/paper.1316e93b.png";